import { useParams } from "react-router";

// Ref: https://github.com/remix-run/react-router/issues/8498#issuecomment-1374529444
export const useRequiredParams = <T extends Record<string, unknown>>(): T => useParams() as T;
